import { AppSettings } from './../Global/app-settings';

export default class BenefitAppSettings extends AppSettings {
    BenefitDocument: string = '';
}